<i18n src="@/lang/actions.json"></i18n>
<i18n src="@/lang/search.json"></i18n>
<i18n src="@/lang/confirmations.json"></i18n>
<i18n src="@/lang/services.json"></i18n>
<i18n>
    {
        "en": {
            "try_delete_widget_in_amo": "Try delete widget in AMO"
        },
        "ua": {
            "try_delete_widget_in_amo": "Try delete widget in AMO"
        },
        "ru": {
            "try_delete_widget_in_amo": "Try delete widget in AMO"
        }
    }
</i18n>

<template>
  <el-main>
    <router-view
      v-if="services"
      :service="show_details_for"
      :amo="amo"
      :customer="customer"
      :services="services"
      :key="`s-${services.length}`"
    />
    <div
      v-show="
        [
          'customers-services-v3',
          'customers.details.installed_services'
        ].includes($route.name)
      "
      :__key="services.length"
    >
      <component
        :is="require('../_snippets/header_actions/header_actions').default"
      >
        <template v-if="customer" v-slot:left-side>
          <el-button
            icon="el-icon-d-arrow-left"
            @click="
              () => $router.replace({ name: $route.name.replace(/.\w+$/, '') })
            "
          >
            {{ $t("actions.go_back") }}
          </el-button>
        </template>
        <template v-if="!customer">
          <template slot="left-side">
            <el-input
              v-model="
                $store.state.shared_customers_services_list.filter_string
              "
              class="filter-input-field"
              size="small"
              spa-action="find"
              clearable
              @change="addToFilterStrings"
            >
              <el-tag
                v-for="tag in $store.state.shared_customers_services_list
                  .filter_strings"
                :key="tag"
                slot="prepend"
                size="small"
                closable
                :disable-transitions="false"
                @close="deleteFromFilterStrings(tag)"
                >{{ tag }}
              </el-tag>
              <el-tooltip
                v-if="
                  $store.state.shared_customers_services_list.filter_strings
                    .length
                "
                slot="append"
                class="item"
                effect="dark"
                :content="$t('actions.clear_all_filter_strings')"
                placement="bottom-end"
              >
                <el-button icon="el-icon-close" @click="clearAllFilters" />
              </el-tooltip>
            </el-input>
          </template>
          <template slot="button-group">
            <el-button-group>
              <el-button
                icon="el-icon-s-tools"
                type="primary"
                @click="tools_drawer = true"
              >
                {{ $t("actions.show_tools") }}
              </el-button>
            </el-button-group>
          </template>
        </template>
        <template v-else>
          <el-button-group v-if="amo" slot="button-group">
            <el-button
              v-if="amo.password"
              type="primary"
              v-text="`${$t('actions.add_new')} ${$t('services.type.widget')}`"
              @click="
                $router.push({
                  name: 'customers.details.installed_services.install',
                  params: $route.params
                })
              "
            />
            <el-button
              type="info"
              v-text="`${$t('actions.add_new')} ${$t('services.type.script')}`"
              @click="
                $router.push({
                  name: 'customers.details.installed_services.install_script',
                  params: $route.params
                })
              "
            />
          </el-button-group>
          <template v-else slot="button-group"><div /></template>
        </template>
      </component>
      <services-table
        :data="services"
        @handleAction="handleAction"
        @handleShowDetails="handleShowDetails"
      />
      <component
        :is="require('../_snippets/popup/popup_912x616').default"
        :visible.sync="show_selected"
        :show-close="false"
        :close-on-click-modal="false"
      >
        <template slot="content" v-if="show_selected">
          <el-container>
            <el-main>
              <sub-element
                ref="service_card"
                :value="
                  Object.assign(
                    Object.create(Object.getPrototypeOf(cur_selected)),
                    cur_selected
                  )
                "
                @action="handleAction"
              />
            </el-main>
          </el-container>
        </template>
      </component>
      <el-drawer
        class="tools-drawer"
        title="I am the title"
        :visible.sync="tools_drawer"
        direction="rtl"
      >
        <filter-tools
          v-if="tools_drawer"
          v-model="$store.state.shared_customers_services_list.filter_string"
          :filter-strings="
            $store.state.shared_customers_services_list.filter_strings
          "
          :add-to-filter-strings="addToFilterStrings"
          :delete-from-filter-strings="deleteFromFilterStrings"
          :delete-from-apply-group-by="deleteFromApplyGroupBy"
          :add-to-apply-group-by="addToApplyGroupBy"
          :group-by="group_by"
          :apply-group-by="apply_group_by"
        />
      </el-drawer>
    </div>
  </el-main>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import ServicesTable from "./elements/services-table";
import FilterTools from "./elements/filter-tools";
import SubElement from "../_snippets/sub_elements/sub-element-contact";

export default {
  name: "ServicesList",
  components: { FilterTools, ServicesTable, SubElement },
  props: {
    customer: Object,
    amocrmList: { type: Array, default: () => [] },
    // service: Object,

    id: String, // this is Customer id
    amo_id: String,
    service_id: String
  },
  data: () => ({
    cur_selected: null,
    show_selected: false,
    tools_drawer: false
  }),
  async created() {
    this.getData();
  },
  methods: {
    ...mapMutations({
      deleteFromApplyGroupBy:
        "shared_customers_services_list/deleteFromApplyGroupBy",
      addToApplyGroupBy: "shared_customers_services_list/addToApplyGroupBy",
      addToFilterStrings: "shared_customers_services_list/addToFilterStrings",
      deleteFromFilterStrings:
        "shared_customers_services_list/deleteFromFilterStrings",
      resetState: "shared_customers_services_list/resetState",
      clearAllFilters: "shared_customers_services_list/clearAllFilters"
    }),
    getData() {
      this.$api.query(this.refetchQueries[0]);
    },
    handleAction(name, params, model) {
      this.$log(arguments);
      switch (name) {
        case "save":
          Object.assign(this.cur_selected, model);
          break;
        case "delete":
          // eslint-disable-next-line no-case-declarations
          let tryDelete = false;
          // eslint-disable-next-line no-case-declarations
          let h = this.$createElement;
          // eslint-disable-next-line no-case-declarations
          let message = !model.isWidget
            ? h("div", {
                domProps: {
                  innerHTML: this.$t(
                    "confirmations.services_list.before_deleting_service"
                  )
                }
              })
            : h("div", { style: { "margin-bottom": "20px" } }, [
                h("div", {
                  style: {
                    "margin-bottom": "20px"
                  },
                  domProps: {
                    innerHTML:
                      this.$t(
                        "confirmations.services_list.before_deleting_service"
                      ) + "<br>"
                  }
                }),
                h(
                  "el-checkbox",
                  {
                    key: Date.now(),
                    on: {
                      input: (...args) => {
                        console.log(tryDelete, args);
                        tryDelete = args[0];
                      }
                    }
                  },
                  this.$t("try_delete_widget_in_amo")
                )
              ]);
          this.$confirm(message, {
            confirmButtonText: this.$t("actions.delete"),
            cancelButtonText: this.$t("actions.cancel"),
            type: "warning",
            center: true,
            dangerouslyUseHTMLString: true
          })
            .then(() => {
              model._handleDelete(tryDelete).then(res => {
                this.getData();
              });
            })
            .catch(() => {});
          break;
        case "open_for_edit":
          this.handleEdit(params, model);
          setTimeout(() => {
            this.$refs.service_card.cur_edit_mode = true;
          }, 10);
          break;
        case "cancel":
          if (!model.uuid) {
            this.services.shift();
          }
        // eslint-disable-next-line no-fallthrough
        case "close":
          this.cur_selected = null;
          this.show_selected = false;
          break;
        default:
          break;
      }
    },
    handleEdit(index, row) {
      this.$log(index, row);
      this.cur_selected = row;
      this.show_selected = true;
    },
    handleShowDetails(...args) {
      switch (this.$route.name) {
        case "customers-services-v3":
          this.$router.push({
            name: "customers-services-v3.details",
            params: { service_id: args[1].uuid }
          });
          break;
        case "customers.details.installed_services":
          this.$router.push({
            name: "customers.details.installed_services.details",
            params: { service_id: args[1].uuid }
          });
          break;
        default:
          break;
      }
    }
  },
  computed: {
    ...mapGetters({
      services_getter: "shared_customers_services_list/services",
      group_by: "shared_customers_services_list/group_by"
    }),
    ...mapState("shared_customers_services_list", ["apply_group_by"]),
    services() {
      return this.services_getter(!!this.customer);
    },
    show_details_for() {
      return this.services.find(v => v.uuid === this.service_id);
    },
    amo() {
      return this.amocrmList.find(v => v.uuid === this.$route.params.amo_id);
    },
    vars() {
      return {
        customer: (this.customer || {}).uuid,
        amo: (this.amo || {}).uuid
      };
    },
    refetchQueries() {
      return [
        {
          query: require("../../graphql/services/services_list.graphql"),
          variables: this.vars
        }
      ];
    }
  }
};
</script>

<style lang="stylus">
.tools-drawer .el-drawer
    padding 5px

    & .el-main
        border 1px solid lightgrey
        border-radius 3px

.filter-input-field
    user-select none
</style>

<style scoped lang="stylus">
[class^=el-icon-]
    font-weight bold

.details-label
    width 75px
    margin-right 20px
    font-weight bold

    &:after
        content ":"
</style>
